import React from 'react';
import { FilterList, Accordion } from '@monorepo/ui-kit';
import { toSelectOptions, useSearchString } from '@monorepo/helpers';
import { useI18n } from '@monorepo/i18n';
import { FILTER_PARAMS } from '@monorepo/dictionary';
import { TDictionaryFilter } from '@monorepo/type';

const ProductGroupFilter: FC<TDictionaryFilter> = ({ onFilterSet, items }) => {
  const { t } = useI18n();
  const { getParamByName } = useSearchString();
  const productGroupId = getParamByName(FILTER_PARAMS.productGroupId, true);

  return (
    <Accordion label={t('orders.filter.product.group')} isDefaultOpen>
      <FilterList
        id={FILTER_PARAMS.productGroupId}
        items={toSelectOptions(items, 'id', 'name')}
        onChange={(val) => onFilterSet(FILTER_PARAMS.productGroupId, val)}
        defaultChecked={productGroupId}
      />
    </Accordion>
  );
};

export default ProductGroupFilter;
